export default __webpack_public_path__ + "static/media/hierarchy_white.61b979aa.svg";